
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

interface StaticVueData {
	message: string;
	buttonLabel: string;
	buttonRoute: string;
}

@Component
export default class Static extends Vue {
	pageData: StaticVueData = {
		message: '',
		buttonLabel: '',
		buttonRoute: '',
	};

	beforeMount() {
		this.pageData = this.$route.meta.staticData;
	}

	redirect() {
		this.$router.push({ name: this.pageData.buttonRoute });
	}
}
